const lazyScrollerClass = ".vue-recycle-scroller__item-view";

/**
 * This method creates two helper functions, show and hide, which are meant to be passed to a b-dropdown
 * Because that the b-dropdown fires first the show and then the hide method if you select a dropdown while another dropdown is open
 * we somehow have to remember how many dropdowns are open. Thus, we increment or decrement whenever a dropdown opens/hides in the same
 * recycle-scroller item
 * @returns {show: Function, hide: Function}
 */
export default function useEventListZIndexFix() {
  const show = (event: Event | { target: HTMLElement }) => {
    const elem = event.target as HTMLElement;
    const scrollerItem = elem.closest<HTMLElement>(lazyScrollerClass);
    if (!scrollerItem) {
      return;
    }
    if (!scrollerItem.style.zIndex) {
      scrollerItem.style.zIndex = "1";
    } else {
      scrollerItem.style.zIndex = (parseInt(scrollerItem.style.zIndex, 10) + 1).toString();
    }
  };
  const hide = (event: Event | { target: HTMLElement }) => {
    const elem = event.target as HTMLElement;
    const scrollerItem = elem.closest<HTMLElement>(lazyScrollerClass);
    if (!scrollerItem) {
      return;
    }
    if (parseInt(scrollerItem.style.zIndex, 10) <= 1) {
      scrollerItem.style.removeProperty("z-index");
    } else {
      scrollerItem.style.zIndex = (parseInt(scrollerItem.style.zIndex, 10) - 1).toString();
    }
  };
  return { show, hide };
}
